import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../context/auth";
import { Link } from "react-router-dom";
import moment from "moment";
import { VerConfiguracion } from "./modalVerConfiguracion";
/*import { ConfigMina } from './configuracionesDeModulos/modalConfigMinas';
import { ConfigProduccion } from './configuracionesDeModulos/modalConfigProduc'; */
import axios from "axios";

/* Almacen */
import { GestionarMedida } from "./almacen/gestionarUnidadMedida";
import { GestionarDepartamento } from "./almacen/gestionarDepartamento";
import { GestionarMarca } from "./almacen/gestionarMarca";
import { GestionarModelo } from "./almacen/gestionarModelo";
import { GestionarProducto } from "./almacen/gestionarProducto";
import { GestionarTipoProducto } from "./almacen/gestionarTipoProducto";
import { GestionarBanco } from "./finanzas/gestionarBanco";
import { GestionarUbicaciones } from "./almacen/gestionarUbicacioes";
import { VerConfiguracionAthos } from "./modalVerConfiguracionAthos";
import { GestionarTipoVacio } from "./almacen/gestionarTipoVacio";
import { ImprimirProductos } from "./almacen/modalImprimirProductos";
import { ImprimirNotasdeDebitos } from "./ventas/modalImprimirNDebitos";
import { ImprimirCuentasxCobrarEstadosCuentas } from "./finanzas/modalImprimirCtasxCobrarEstadoCuenta";
import { CatPermisosUsuarios } from "../catalogos/modalPermisosusuario";
import { Mensaje } from "./mensajes";
import { ModalImprimirRecibosdePago } from "./finanzas/ImprimirRecibosdePagos";
import { ModalOperacionesInventario } from "./almacen/ImprimirOpInventarios";
import { GestionarFabricantes } from "./almacen/gestionarFabricante";
import { ModalVentasGanancias } from "./almacen/ImprimirMovimientosVentas";
import { ImprimirAnticipos } from "./finanzas/modalImprimirAnticipos";
import { ImpMovBanLibro } from "./finanzas/impMovBanSegunLibro";
import { ModalVentasxProductos } from "./ventas/ImprimirMovimientosVentasP";
import { ModalImprimirFacturasCompras } from "./compra/ImprimirCompras";
import { GestionarClasificadorVacios } from "./vacios/gestionarClasificadorVacios";
import { ModalPermisosUsuarisServicios } from "./servicios/modalPermisosServicios";
import { ImprimirNotasdeCredito } from "./ventas/modalImprimirNCredito";
import { GestionarpServicios } from "./servicios/gestionarServicios";
import { ModalImprimirIngresos } from "./finanzas/imprimirIngresos";
import { ImprimirAnticiposxVendedor } from "./finanzas/modalImprimirAnticiposxVendedor";
import { ImprimirDeudasGenerales } from "./finanzas/modalImprimirDeudaGeneral";
import { ImprimirControlVacios } from "./vacios/modalImprimirControlVacios";
import { ModalImprimirOpObsequio } from "./almacen/imprimirOpObsequio";
import { ModalPedidosPendientes } from "./ventas/ImprimirPedidosPendientes";
import { ModalImprimirRecibosReversados } from "./finanzas/imprimirRecibosReversado";
import { ModalClientes } from "./ventas/modalClientes";
import { ModalPicking } from "./ventas/modalReportePicking";
function Sidebar(props) {
  moment.locale("es");
  let op = require("../../public/modulos/datos");
  let token = sessionStorage.getItem("jwtToken");

  let logo = JSON.parse(sessionStorage.getItem("logo"));
  let rif = JSON.parse(sessionStorage.getItem("riforganizacion"));
  let organizacion = JSON.parse(sessionStorage.getItem("organizacion"));
  let idorganizacion = JSON.parse(sessionStorage.getItem("idorganizacion"));
  const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
  const iduser = JSON.parse(sessionStorage.getItem("idusuario"));

  const txtmodulo = JSON.parse(sessionStorage.getItem("txtmodulo"));
  const txtfranquicia = JSON.parse(sessionStorage.getItem("txtfranquicia"));

  const permisos = JSON.parse(sessionStorage.getItem("permisos"));
  const accinventario = JSON.parse(sessionStorage.getItem("accinventarioc"));
  const accventas = JSON.parse(sessionStorage.getItem("accventasc"));
  const acccompras = JSON.parse(sessionStorage.getItem("acccomprasc"));
  const accbtncreports = JSON.parse(sessionStorage.getItem("accbtncreportsc"));
  const acccontabilidad = JSON.parse(
    sessionStorage.getItem("acccontabilidadc")
  );
  const accfinanzas = JSON.parse(sessionStorage.getItem("accfinanzasc"));
  const accbtnireports = JSON.parse(sessionStorage.getItem("accbtnireportsc"));
  const accbtnvreports = JSON.parse(sessionStorage.getItem("accbtnvreportsc"));
  const accbtnfreports = JSON.parse(sessionStorage.getItem("accbtnfreportsc"));
  const accvacios = JSON.parse(sessionStorage.getItem("accvaciosc"));
  const accservicios = JSON.parse(sessionStorage.getItem("accserviciosc"));
  const btnreportvacios = JSON.parse(
    sessionStorage.getItem("btnreportvaciosc")
  );
  const accpostventas = JSON.parse(sessionStorage.getItem("accpostventasc"));
  console.log(accfinanzas)
  /* modals */

  const [mostrarMedida, setMostrarMedida] = useState(false);
  const [mostrarDepart, setMostrarDepart] = useState(false);
  const [mostrarMarca, setMostrarMarca] = useState(false);
  const [mostrarModelo, setMostrarModelo] = useState(false);
  const [mostrarProducto, setMostrarProducto] = useState(false);
  const [mostrarTipoProducto, setMostrarTipoProducto] = useState(false);
  const [mostrarBanco, setMostrarBanco] = useState(false);
  const [creport, setCreport] = useState("");
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [creportestc, setCreportestc] = useState("");
  const [tipopermi, setTipopermi] = useState("");
  const [mostrarUbicaciones, setMostrarUbicaciones] = useState(false);
  const [mostrarTipoVacio, setMostrarTipoVacio] = useState(false);
  const [mostrarReportProductos, setMostrarReportProductos] = useState(false);
  const [mostrarReportNDebitos, setMostrarReportNDebitos] = useState(false);
  const [mostrarReportNCredito, setMostrarReportNCredito] = useState(false);
  const [mpermisousuarios, setMpermisousuarios] = useState(false);
  const [mostrarReportEsc, setMostrarReportEsc] = useState(false);

  const { user, logout } = useContext(AuthContext);
  const fechaSistema = JSON.parse(sessionStorage.getItem("fechasistema"));
  const [valrport, setValrport] = useState("");
  const [tituloNav, setTituloNav] = useState("Panel de Control");
  const [verConfiguracion, setVerConfiguracion] = useState(false);
  const [verConfiguAthos, setVerConfiguAthos] = useState(false);
  const [mostrar, setMostrar] = useState(false);
  const [mostrar1, setMostrar1] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [mostrar4, setMostrar4] = useState(false);
  const [mostrar5, setMostrar5] = useState(false);
  const [mostrar6, setMostrar6] = useState(false);
  const [mostrar7, setMostrar7] = useState(false);
  const [mostrar8, setMostrar8] = useState(false);
  const [mostrar9, setMostrar9] = useState(false);
  const [mostrar10, setMostrar10] = useState(false);
  const [mostrar11, setMostrar11] = useState(false);
  const [mostrar12, setMostrar12] = useState(false);
  const [mostrar13, setMostrar13] = useState(false);
  const [mostrar14, setMostrar14] = useState(false);
  const [mostrar15, setMostrar15] = useState(false);
  const [mostrar16, setMostrar16] = useState(false);
  const [mostrar17, setMostrar17] = useState(false);
  const [mostrar18, setMostrar18] = useState(false);

  const configuracionSistema = () => {
    const campos = "*";
    const nomtab = "configsistema";

    const endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=idconfig&id=1`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          console.log(response.data);
          sessionStorage.setItem(
            "tiporeppedido",
            JSON.stringify(response.data.tiporeppedido)
          );
          sessionStorage.setItem(
            "tiporepnotaentrega",
            JSON.stringify(response.data.tiporepnotaentrega)
          );
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    configuracionSistema();
  }, []);

  let el;
  let ele;
  const bloquear = (titulo) => (e) => {
    e.preventDefault();
    setTituloNav(titulo);
    props.onCambiar(titulo);
    if ((el = document.getElementById("wrapper"))) {
      el.classList.toggle("toggled");
      if ((ele = document.getElementById("menu-toggle"))) {
        ele.classList.toggle("bloquear");
      }
    }
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const abrirModal = (tipo) => (e) => {
    e.preventDefault();
    el = document.getElementById("wrapper");
    el.classList.toggle("toggled");
    if (tipo === "medida") {
      setMostrarMedida(true);
    } else if (tipo === "departamento") {
      setMostrarDepart(true);
    } else if (tipo === "marca") {
      setMostrarMarca(true);
    } else if (tipo === "modelo") {
      setMostrarModelo(true);
    } else if (tipo === "fabricante") {
      setMostrar(true);
    } else if (tipo === "tipoproducto") {
      setMostrarTipoProducto(true);
    } else if (tipo === "producto") {
      setMostrarProducto(true);
    } else if (tipo === "banco") {
      setMostrarBanco(true);
    } else if (tipo === "ubicacion") {
      setMostrarUbicaciones(true);
    } else if (tipo === "tipovacio") {
      setMostrarTipoVacio(true);
    } else if (tipo === "reporteproducto") {
      setMostrarReportProductos(true);
    } else if (tipo === "reportenotaentrega") {
      setCreport(tipo);
      setMostrarReportNDebitos(true);
    } else if (tipo === "reportenotadebitos") {
      setCreport(tipo);
      setMostrarReportNDebitos(true);
    } else if (tipo === "reporteobsequio") {
      setCreport(tipo);
      setMostrarReportNDebitos(true);
    } else if (tipo === "reportenotascredito") {
      setCreport(tipo);
      setMostrarReportNCredito(true);
    } else if (tipo === "reporteestadodecuenta") {
      setCreportestc(tipo);
      setMostrarReportEsc(true);
    } else if (tipo === "reportecuentasporcobrar") {
      setCreportestc(tipo);
      setMostrarReportEsc(true);
    } else if (tipo === "reportefacturas") {
      setCreport(tipo);
      setMostrarReportNDebitos(true);
    } else if (tipo === "reportepedidos") {
      setCreport(tipo);
      setMostrarReportNDebitos(true);
    } else if (
      tipo === "Inventario" ||
      tipo === "Ventas" ||
      tipo === "Compras" ||
      tipo === "Contabilidad" ||
      tipo === "Finanzas" ||
      tipo === "Vacios" ||
      tipo === "Servicios"
    ) {
      setTipopermi(tipo);
      setMpermisousuarios(true);
    } else if (tipo === "reporterecibodepago") {
      setCreport(tipo);
      setMostrar2(true);
    } else if (tipo === "opinventario") {
      setMostrar1(true);
    } else if (tipo === "reporteventasganancias") {
      setMostrar3(true);
    } else if (tipo === "reporteanticipos") {
      setMostrar4(true);
    } else if (tipo === "reporteanticiposxvendedor") {
      setMostrar11(true);
    } else if (tipo === "reportelibrobanco") {
      setMostrar5(true);
    } else if (tipo === "reporteventasxproductos") {
      setMostrar6(true);
    } else if (tipo === "reportefacturasdecompra") {
      setMostrar7(true);
    } else if (tipo === "classvacios") {
      setMostrar8(true);
    } else if (tipo === "gestionservicios") {
      setMostrar9(true);
    } else if (tipo === "reporteingresos") {
      setValrport(tipo);
      setMostrar10(true);
    } else if (tipo === "reportelibroventas") {
      setValrport(tipo);
      setMostrar10(true);
    } else if (tipo === "repordeudasgen") {
      setMostrar12(true);
    } else if (tipo === "reportecontrolvacios") {
      setMostrar13(true);
    } else if (tipo === "opinventarioobsequio") {
      setMostrar14(true);
    } else if (tipo === "ReporteListaPedidosPendiente") {
      setMostrar15(true);
    } else if (tipo === "reporterecibosreversados") {
      setMostrar16(true);
    } else if (tipo === "reporteclientes") {
      setMostrar17(true);
    } else if (tipo === "ReportePickingList") {
      setMostrar18(true);
    }
    //
  };

  /* Ubica el submenu al lado del item y dentro de la ventana, de modo que no
     caiga hacia abajo ni necesite margenes negativos (mt-222m, mt-200m, etc.) */
  const ajustarSubmenu = (e) => {
    const li = e.target && e.target.closest ? e.target.closest("li") : null;

    if (
      !li ||
      !li.parentElement ||
      !li.parentElement.classList.contains("dropdown-menu")
    ) {
      return;
    }

    const submenu = li.querySelector(":scope > .dropdown-submenu");

    if (!submenu) {
      return;
    }

    const margen = 8;
    const display = submenu.style.display;
    const visibility = submenu.style.visibility;

    /* Se mide el submenu aunque todavia no este visible */
    submenu.style.display = "block";
    submenu.style.visibility = "hidden";

    const alto = submenu.offsetHeight;
    const item = li.getBoundingClientRect();

    /* Vertical: alineado con el item y, si no cabe, ajustado a la ventana */
    let top = 0;

    if (item.top + alto > window.innerHeight - margen) {
      top = window.innerHeight - margen - alto - item.top;
    }

    if (item.top + top < margen) {
      top = margen - item.top;
    }

    submenu.style.top = `${top}px`;

    /* Si el submenu es mas alto que la ventana se limita y se habilita scroll */
    if (alto > window.innerHeight - margen * 2) {
      submenu.style.maxHeight = `${window.innerHeight - margen * 2}px`;
      submenu.style.overflowY = "auto";
    } else {
      submenu.style.maxHeight = "";
      submenu.style.overflowY = "";
    }

    /* Horizontal: se abre a la derecha y, si no cabe, se voltea a la izquierda */
    if (item.right + submenu.offsetWidth + margen > window.innerWidth) {
      submenu.classList.add("dropdown-submenu-left");
    } else {
      submenu.classList.remove("dropdown-submenu-left");
    }

    submenu.style.display = display;
    submenu.style.visibility = visibility;
  };

  const verConfig = () => {
    if (!verConfiguracion) {
      setVerConfiguracion(true);
    } else {
      setVerConfiguracion(false);
    }
  };

  const verConfigAthos = () => {
    setVerConfiguAthos(true);
  };

  const sidebar = user && (
    <div className="amanecergris" id="sidebar-wrapper">
      <div className="sidebar-heading text-center py-4 bluez-text fs-4 fw-bold text-uppercase border-bottom">
        <img
          className="img-fluid"
          src={`${op.conexion}/imagen?img=athos/organizacion/${logo}`}
          style={{ width: "100px" }}
          alt=""
        />
        <h5 className="m-0 second-text">{rif}</h5>
      </div>
      <div className="list-group list-group-flush " onMouseOver={ajustarSubmenu}>
        <div className="list-group list-group-flush">
          <Link
            to="/inicio"
            className="list-group-item list-group-item-action py-2 ripple active text-center"
          >
            <h3 className="H">{organizacion}</h3>
          </Link>

          {permisos && permisos.substring(0, 1) === "1" ? (
            <div className="dropdown dropend ">
              <a
                className="btn-primary dropdown-toggle list-group-item list-group-item-action py-2 ripple px-2"
                style={{
                  pointerEvents:
                    permisos && permisos.substring(0, 1) === "0"
                      ? "none"
                      : "cursor",
                  color:
                    permisos && permisos.substring(0, 1) === "0"
                      ? "rgb(183, 183, 183)"
                      : "#1d0345",
                  backgroundColor:
                    permisos && permisos.substring(0, 1) === "0"
                      ? "rgba(144, 143, 142, 0.76)"
                      : "transparent",
                }}
                type="button"
                id="dropdownMenuButton"
                data-mdb-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fas fa-ticket-alt fa-fw me-2" />
                <span className="fw-bold">INVENTARIO</span>
              </a>
              <ul
                className="dropdown-menu sombras "
                aria-labelledby="dropdownMenuButton"
              >
                {accinventario && accinventario.substring(0, 1) === "1" && (
                  <li onClick={bloquear("Registro de Almacenes")}>
                    <Link
                      to="/registroalmacen"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-box-open fa-fw me-1" />
                        REGISTRO DE ALMACENES
                      </span>
                    </Link>
                  </li>
                )}

                {accinventario && accinventario.substring(1, 2) === "1" && (
                  <li onClick={abrirModal("ubicacion")}>
                    <Link
                      to="#"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-map-marker-alt fa-fw me-1" />
                        UBICACIONES DE ALMACENES
                      </span>
                    </Link>
                  </li>
                )}

                {accinventario && accinventario.substring(2, 3) === "1" && (
                  <li onClick={abrirModal("medida")}>
                    <Link
                      to="#"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-poll-h fa-fw me-1" />
                        UNIDADES DE MEDIDAS
                      </span>
                    </Link>
                  </li>
                )}

                {accinventario && accinventario.substring(3, 4) === "1" && (
                  <li onClick={abrirModal("marca")}>
                    <Link
                      to="#"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="far fa-bookmark fa-fw me-1" />
                        MARCA
                      </span>
                    </Link>
                  </li>
                )}

                {accinventario && accinventario.substring(4, 5) === "1" && (
                  <li onClick={abrirModal("modelo")}>
                    <Link
                      to="#"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-tag fa-fw me-1" />
                        MODELO
                      </span>
                    </Link>
                  </li>
                )}

                {accinventario && accinventario.substring(4, 5) === "1" && (
                  <li onClick={abrirModal("fabricante")}>
                    <Link
                      to="#"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-signature fa-fw me-1" />
                        FABRICANTE
                      </span>
                    </Link>
                  </li>
                )}

                {accinventario && accinventario.substring(5, 6) === "1" && (
                  <li onClick={abrirModal("tipoproducto")}>
                    <Link
                      to="#"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fab fa-stack-exchange fa-fw me-1" />
                        TIPO DE PRODUCTO
                      </span>
                    </Link>
                  </li>
                )}

                {accinventario && accinventario.substring(6, 7) === "1" && (
                  <li onClick={bloquear("")}>
                    <Link
                      to="/producto"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-boxes fa-fw me-1" />
                        PRODUCTOS
                      </span>
                    </Link>
                  </li>
                )}

                {accinventario && accinventario.substring(7, 8) === "1" && (
                  <li onClick={bloquear(" ")}>
                    <Link
                      to="/operacionesinv"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-share-square fa-fw me-1" />
                        OPERACIONES DE INVENTARIO
                      </span>
                    </Link>
                  </li>
                )}

                {accinventario && accinventario.substring(10, 11) === "1" && (
                  <li>
                    <a
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                      href="#"
                    >
                      <span>
                        <i className="fas fa-cog fa-fw me-1" />
                        CONFIGURACION »
                      </span>
                    </a>
                    <ul className="dropdown-menu dropdown-submenu sombras">
                      <li onClick={abrirModal("Inventario")}>
                        <Link className="dropdown-item ripple bg-transparent text-dark fw-bold">
                          <span>
                            <i className="fas fa-user-cog fa-fw me-1" />
                            PERMISOS DE USUARIO
                          </span>
                        </Link>
                      </li>
                    </ul>
                  </li>
                )}

                <li>
                  <hr className="dropdown-divider" />
                </li>

                {accinventario && accinventario.substring(11, 12) === "1" && (
                  <li>
                    <a
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                      href="#"
                    >
                      <i className="fas fa-print fa-fw me-1" />
                      REPORTES »
                    </a>
                    <ul className="dropdown-menu dropdown-submenu sombras">
                      {accbtnireports &&
                        accbtnireports.toString().substring(0, 1) === "1" ? (
                        <li
                          onClick={() =>
                            window.open(
                              `${op.reportes}/productos?afiliado=${afiliado}&reporte=ListaProductos`,
                              "Planilla",
                              "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
                            )
                          }
                        >
                          <Link
                            to="#"
                            className={
                              "dropdown-item ripple bg-transparent text-dark fw-bold"
                            }
                          >
                            <span>
                              <i className="far fa-file-pdf fa-fw me-1" />
                              Lista de Productos
                            </span>
                          </Link>
                        </li>
                      ) : (
                        ""
                      )}
                      <li
                        onClick={() =>
                          window.open(
                            `${op.reportes}/productos?afiliado=${afiliado}&reporte=ListProductoExistenciaCatalogo2`,
                            "Planilla",
                            "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
                          )
                        }
                      >
                        <Link
                          to="#"
                          className={
                            "dropdown-item ripple bg-transparent text-dark fw-bold"
                          }
                        >
                          <span>
                            <i className="far fa-file-pdf fa-fw me-1" />
                            Catalogo de Productos
                          </span>
                        </Link>
                      </li>
                      {accbtnireports &&
                        accbtnireports.toString().substring(1, 2) === "1" ? (
                        <li onClick={abrirModal("reporteproducto")}>
                          <Link
                            to="#"
                            className="dropdown-item ripple bg-transparent text-dark fw-bold"
                          >
                            <span className="">
                              <i className="far fa-file-pdf fa-fw me-1" />
                              Lista de Productos en Existencia
                            </span>
                          </Link>
                        </li>
                      ) : (
                        ""
                      )}

                      {accbtnireports &&
                        accbtnireports.toString().substring(2, 3) === "1" ? (
                        <li onClick={abrirModal("opinventario")}>
                          <Link
                            to="#"
                            className="dropdown-item ripple bg-transparent text-dark fw-bold"
                          >
                            <span className="">
                              <i className="far fa-file-pdf fa-fw me-1" />
                              Operaciones de Inventario
                            </span>
                          </Link>
                        </li>
                      ) : (
                        ""
                      )}

                      {accbtnireports &&
                        accbtnireports.toString().substring(3, 4) === "1" ? (
                        <li onClick={abrirModal("opinventarioobsequio")}>
                          <Link
                            to="#"
                            className="dropdown-item ripple bg-transparent text-dark fw-bold"
                          >
                            <span className="">
                              <i className="far fa-file-pdf fa-fw me-1" />
                              Operaciones de Inventario Obsequio/Donaciones
                            </span>
                          </Link>
                        </li>
                      ) : (
                        ""
                      )}
                    </ul>
                  </li>
                )}
              </ul>
            </div>
          ) : (
            ""
          )}

          {permisos && permisos.substring(1, 2) === "1" ? (
            <div className="dropdown dropend ">
              <a
                className="btn-primary dropdown-toggle list-group-item list-group-item-action py-2 ripple px-2"
                style={{
                  pointerEvents:
                    permisos && permisos.substring(1, 2) === "0"
                      ? "none"
                      : "cursor",
                  color:
                    permisos && permisos.substring(1, 2) === "0"
                      ? "rgb(183, 183, 183)"
                      : "#1d0345",
                  backgroundColor:
                    permisos && permisos.substring(1, 2) === "0"
                      ? "rgba(144, 143, 142, 0.76)"
                      : "transparent",
                }}
                type="button"
                id="dropdownMenuButton"
                data-mdb-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fas fa-cash-register fa-fw me-2" />
                <span className="fw-bold">VENTAS</span>
              </a>
              <ul
                className="dropdown-menu sombras "
                aria-labelledby="dropdownMenuButton"
              >
                {accventas && accventas.substring(0, 1) === "0" ? (
                  ""
                ) : txtfranquicia && txtfranquicia === "3" ? (
                  <li onClick={bloquear("Clientes")}>
                    <Link
                      to="/gestionGerencial?modal=cliente"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-user-tie fa-fw me-1" />
                        CLIENTES
                      </span>
                    </Link>
                  </li>
                ) : (
                  <li onClick={bloquear("")}>
                    <Link
                      to="/clientes"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-users fa-fw me-1" />
                        CLIENTES
                      </span>
                    </Link>
                  </li>
                )}

                {accventas && accventas.substring(1, 2) === "0" ? (
                  ""
                ) : txtfranquicia && txtfranquicia === "3" ? (
                  <li onClick={bloquear("Vendedores")}>
                    <Link
                      to="/gestionGerencial?modal=vendedor"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-users fa-fw me-1" />
                        VENDEDORES
                      </span>
                    </Link>
                  </li>
                ) : (
                  <li onClick={bloquear("")}>
                    <Link
                      to="/vendedores"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-user-tie fa-fw me-1" />
                        VENDEDORES
                      </span>
                    </Link>
                  </li>
                )}

                {accventas && accventas.substring(2, 3) === "0" ? (
                  ""
                ) : (
                  <li onClick={bloquear("")}>
                    <Link
                      to="/pedidos"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-edit fa-fw me-1" />
                        PEDIDOS
                      </span>
                    </Link>
                  </li>
                )}

                {accventas && accventas.substring(3, 4) === "0" ? (
                  ""
                ) : (
                  <li onClick={bloquear("")}>
                    <Link
                      to="/notaentrega"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-pen-square fa-fw me-1" />
                        NOTAS DE ENTREGA
                      </span>
                    </Link>
                  </li>
                )}

                {accventas && accventas.substring(4, 5) === "0" ? (
                  ""
                ) : (
                  <li onClick={bloquear("")}>
                    <Link
                      to="/notadebito"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-pen-square fa-fw me-1" />
                        NOTAS DE DEBITO
                      </span>
                    </Link>
                  </li>
                )}

                {accventas && accventas.substring(4, 5) === "0" ? (
                  ""
                ) : (
                  <li onClick={bloquear("")}>
                    <Link
                      to="/notacredito"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-pen-square fa-fw me-1" />
                        NOTAS DE CREDITO
                      </span>
                    </Link>
                  </li>
                )}

                {accventas && accventas.substring(5, 6) === "0" ? (
                  ""
                ) : (
                  <li onClick={bloquear("Facturacion")}>
                    <Link
                      to="/factura"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-receipt fa-fw me-1" />
                        FACTURAS
                      </span>
                    </Link>
                  </li>
                )}

                {accventas && accventas.substring(9, 10) === "0" ? (
                  ""
                ) : (
                  <li onClick={bloquear("Facturacion Por Notas de Entrega")}>
                    <Link
                      to="/facturaxnota"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-receipt fa-fw me-1" />
                        FACTURAS POR NOTAS DE ENTREGA
                      </span>
                    </Link>
                  </li>
                )}

                {accventas && accventas.substring(6, 7) === "0" ? (
                  ""
                ) : (
                  <li onClick={bloquear("")}>
                    <Link
                      to="/presupuesto"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-money-check fa-fw me-1" />
                        PRESUPUESTOS
                      </span>
                    </Link>
                  </li>
                )}

                {accventas && accventas.substring(7, 8) === "0" ? (
                  ""
                ) : (
                  <li>
                    <a
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                      href="#"
                    >
                      <span>
                        <i className="fas fa-cog fa-fw me-1" />
                        CONFIGURACION »
                      </span>
                    </a>
                    <ul className="dropdown-menu dropdown-submenu sombras">
                      <li onClick={abrirModal("Ventas")}>
                        <Link
                          to="#"
                          className="dropdown-item ripple bg-transparent text-dark fw-bold"
                        >
                          <span>
                            <i className="fas fa-user-cog fa-fw me-1" />
                            PERMISOS DE USUARIO
                          </span>
                        </Link>
                      </li>
                    </ul>
                  </li>
                )}

                <li>
                  <hr className="dropdown-divider" />
                </li>

                {accventas && accventas.substring(8, 9) === "0" ? (
                  ""
                ) : (
                  <li>
                    <a
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                      href="#"
                    >
                      <i className="fas fa-print fa-fw me-1" />
                      REPORTES »
                    </a>
                    <ul className="dropdown-menu dropdown-submenu sombras">
                      {accbtnvreports &&
                        accbtnvreports.substring(0, 1) === "1" ? (
                        <li
                          onClick={abrirModal("reporteclientes")}
                        >
                          <Link
                            to="#"
                            className={
                              "dropdown-item ripple bg-transparent text-dark fw-bold"
                            }
                          >
                            <span>
                              <i className="far fa-file-pdf fa-fw me-1" />{" "}
                              Clientes
                            </span>
                          </Link>
                        </li>
                      ) : (
                        ""
                      )}

                      {accbtnvreports &&
                        accbtnvreports.substring(1, 2) === "1" ? (
                        <li onClick={abrirModal("reportepedidos")}>
                          <Link
                            to="#"
                            className="dropdown-item ripple bg-transparent text-dark fw-bold"
                          >
                            <span className="">
                              <i className="far fa-file-pdf fa-fw me-1" />
                              Reporte de Pedidos Generados
                            </span>
                          </Link>
                        </li>
                      ) : (
                        ""
                      )}

                      {accbtnvreports &&
                        accbtnvreports.substring(2, 3) === "1" ? (
                        <li onClick={abrirModal("reportenotaentrega")}>
                          <Link
                            to="#"
                            className="dropdown-item ripple bg-transparent text-dark fw-bold"
                          >
                            <span className="">
                              <i className="far fa-file-pdf fa-fw me-1" />
                              Reporte de Notas de Entrega
                            </span>
                          </Link>
                        </li>
                      ) : (
                        ""
                      )}

                      {accbtnvreports &&
                        accbtnvreports.substring(3, 4) === "1" ? (
                        <li onClick={abrirModal("reportenotadebitos")}>
                          <Link
                            to="#"
                            className="dropdown-item ripple bg-transparent text-dark fw-bold"
                          >
                            <span className="">
                              <i className="far fa-file-pdf fa-fw me-1" />
                              Reporte de Notas de Debito
                            </span>
                          </Link>
                        </li>
                      ) : (
                        ""
                      )}

                      {accbtnvreports &&
                        accbtnvreports.substring(3, 4) === "1" ? (
                        <li onClick={abrirModal("reporteobsequio")}>
                          <Link
                            to="#"
                            className="dropdown-item ripple bg-transparent text-dark fw-bold"
                          >
                            <span className="">
                              <i className="far fa-file-pdf fa-fw me-1" />
                              Reporte de Obsequios/Donación
                            </span>
                          </Link>
                        </li>
                      ) : (
                        ""
                      )}

                      {accbtnvreports &&
                        accbtnvreports.substring(4, 5) === "1" ? (
                        <li onClick={abrirModal("reportenotascredito")}>
                          <Link
                            to="#"
                            className="dropdown-item ripple bg-transparent text-dark fw-bold"
                          >
                            <span className="">
                              <i className="far fa-file-pdf fa-fw me-1" />
                              Reporte de Notas de Crédito
                            </span>
                          </Link>
                        </li>
                      ) : (
                        ""
                      )}

                      {accbtnvreports &&
                        accbtnvreports.substring(5, 6) === "1" ? (
                        <li onClick={abrirModal("reportefacturas")}>
                          <Link
                            to="#"
                            className="dropdown-item ripple bg-transparent text-dark fw-bold"
                          >
                            <span className="">
                              <i className="far fa-file-pdf fa-fw me-1" />
                              Reporte de Facturas Generadas
                            </span>
                          </Link>
                        </li>
                      ) : (
                        ""
                      )}

                      {accbtnvreports &&
                        accbtnvreports.substring(6, 7) === "1" ? (
                        <li onClick={abrirModal("reporteventasganancias")}>
                          <Link
                            to="#"
                            className="dropdown-item ripple bg-transparent text-dark fw-bold"
                          >
                            <span className="">
                              <i className="far fa-file-pdf fa-fw me-1" />
                              Movimientos de Ventas Generadas
                            </span>
                          </Link>
                        </li>
                      ) : (
                        ""
                      )}

                      {accbtnvreports &&
                        accbtnvreports.substring(7, 8) === "1" ? (
                        <li onClick={abrirModal("reporteventasxproductos")}>
                          <Link
                            to="#"
                            className="dropdown-item ripple bg-transparent text-dark fw-bold"
                          >
                            <span className="">
                              <i className="far fa-file-pdf fa-fw me-1" />
                              Movimientos de Ventas por Productos
                            </span>
                          </Link>
                        </li>
                      ) : (
                        ""
                      )}
                      <li onClick={abrirModal("ReporteListaPedidosPendiente")}>
                        <Link
                          to="#"
                          className={
                            "dropdown-item ripple bg-transparent text-dark fw-bold"
                          }
                        >
                          <span>
                            <i className="far fa-file-pdf fa-fw me-1" />
                            Lista de Pedidos Pendientes
                          </span>
                        </Link>
                      </li>
                      <li onClick={abrirModal("ReportePickingList")}>
                        <Link
                          to="#"
                          className={
                            "dropdown-item ripple bg-transparent text-dark fw-bold"
                          }
                        >
                          <span>
                            <i className="far fa-file-pdf fa-fw me-1" />
                            Reporte Picking List
                          </span>
                        </Link>
                      </li>
                    </ul>
                  </li>
                )}
              </ul>
            </div>
          ) : (
            ""
          )}

          {permisos && permisos.substring(8, 9) === "1" ? (
            <div className="dropdown dropend">
              <a
                className="btn-primary dropdown-toggle list-group-item list-group-item-action py-2 ripple px-2"
                style={{
                  pointerEvents:
                    permisos && permisos.substring(8, 9) === "0"
                      ? "none"
                      : "cursor",
                  color:
                    permisos && permisos.substring(8, 9) === "0"
                      ? "rgb(183, 183, 183)"
                      : "#1d0345",
                  backgroundColor:
                    permisos && permisos.substring(8, 9) === "0"
                      ? "rgba(144, 143, 142, 0.76)"
                      : "transparent",
                }}
                type="button"
                id="dropdownMenuButton"
                data-mdb-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fas fa-cash-register fa-fw me-2" />
                <span className="fw-bold">POST-VENTA</span>
              </a>
              <ul
                className="dropdown-menu sombras "
                aria-labelledby="dropdownMenuButton"
              >
                {accpostventas && accpostventas.substring(0, 1) === "0" ? (
                  ""
                ) : (
                  <li onClick={bloquear("Post-Venta")}>
                    <Link
                      to="/postventa"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-edit fa-fw me-1" />
                        VENTA
                      </span>
                    </Link>
                  </li>
                )}

                {accpostventas && accpostventas.substring(0, 1) === "1" && (
                  <li>
                    <a
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                      href="#"
                    >
                      <i className="fas fa-print fa-fw me-1" />
                      REPORTES »
                    </a>
                    <ul className="dropdown-menu dropdown-submenu sombras">
                      {accbtnvreports &&
                        accbtnvreports.substring(2, 3) === "1" ? (
                        <li onClick={abrirModal("reportenotaentrega")}>
                          <Link
                            to="#"
                            className="dropdown-item ripple bg-transparent text-dark fw-bold"
                          >
                            <span className="">
                              <i className="far fa-file-pdf fa-fw me-1" />
                              Reporte de Notas de Entrega
                            </span>
                          </Link>
                        </li>
                      ) : (
                        ""
                      )}

                      {accbtnvreports &&
                        accbtnvreports.substring(7, 8) === "1" ? (
                        <li onClick={abrirModal("reporteventasxproductos")}>
                          <Link
                            to="#"
                            className="dropdown-item ripple bg-transparent text-dark fw-bold"
                          >
                            <span className="">
                              <i className="far fa-file-pdf fa-fw me-1" />
                              Movimientos de Ventas por Productos
                            </span>
                          </Link>
                        </li>
                      ) : (
                        ""
                      )}

                      {accbtnfreports &&
                        accbtnfreports.substring(5, 6) === "1" ? (
                        <li onClick={abrirModal("reporteingresos")}>
                          <Link
                            to="#"
                            className="dropdown-item ripple bg-transparent text-dark fw-bold"
                          >
                            <span className="">
                              <i className="far fa-file-pdf fa-fw me-1" />
                              Imprimir Ingresos
                            </span>
                          </Link>
                        </li>
                      ) : (
                        ""
                      )}
                    </ul>
                  </li>
                )}
              </ul>
            </div>
          ) : (
            ""
          )}

          {idorganizacion && idorganizacion === "1" && (iduser && parseInt(iduser) === 1 || parseInt(iduser) === 2 || parseInt(iduser) === 30) && permisos && permisos.substring(7, 8) === "1" ? (
            <div className="dropdown dropend">
              <a
                className="btn-primary dropdown-toggle list-group-item list-group-item-action py-2 ripple px-2"
                style={{
                  pointerEvents:
                    permisos && permisos.substring(7, 8) === "0"
                      ? "none"
                      : "cursor",
                  color:
                    permisos && permisos.substring(7, 8) === "0"
                      ? "rgb(183, 183, 183)"
                      : "#1d0345",
                  backgroundColor:
                    permisos && permisos.substring(7, 8) === "0"
                      ? "rgba(144, 143, 142, 0.76)"
                      : "transparent",
                }}
                type="button"
                id="dropdownMenuButton"
                data-mdb-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fas fa-tools fa-fw me-2" />
                <span className="fw-bold">SERVICIOS</span>
              </a>
              <ul
                className="dropdown-menu sombras "
                aria-labelledby="dropdownMenuButton"
              >
                {accservicios && accservicios.substring(2, 3) === "0" ? (
                  ""
                ) : (
                  <li onClick={abrirModal("gestionservicios")}>
                    <Link
                      to="#"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-edit fa-fw me-1" />
                        GESTION DE SERVICIOS
                      </span>
                    </Link>
                  </li>
                )}

                {accservicios && accservicios.substring(1, 2) === "0" ? (
                  ""
                ) : (
                  <li onClick={bloquear("")}>
                    <Link
                      to="/gestionmoviles"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-tractor fa-fw me-1" />
                        GESTIÓN DE MOVILES
                      </span>
                    </Link>
                  </li>
                )}

                {accservicios && accservicios.substring(0, 1) === "0" ? (
                  ""
                ) : (
                  <li onClick={bloquear("")}>
                    <Link
                      to="/orderservicio"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-edit fa-fw me-1" />
                        ORDENES DE SERVICIO
                      </span>
                    </Link>
                  </li>
                )}

                {accservicios && accservicios.substring(3, 4) === "0" ? (
                  ""
                ) : (
                  <li onClick={bloquear("")}>
                    <Link
                      to="/notaentregaserv"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-edit fa-fw me-1" />
                        NOTA DE ENTREGA
                      </span>
                    </Link>
                  </li>
                )}

                {accservicios && accservicios.substring(4, 5) === "0" ? (
                  ""
                ) : (
                  <li>
                    <a
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                      href="#"
                    >
                      <span>
                        <i className="fas fa-cog fa-fw me-1" />
                        CONFIGURACION »
                      </span>
                    </a>
                    <ul className="dropdown-menu dropdown-submenu sombras">
                      <li onClick={abrirModal("Servicios")}>
                        <Link
                          to="#"
                          className="dropdown-item ripple bg-transparent text-dark fw-bold"
                        >
                          <span>
                            <i className="fas fa-user-cog fa-fw me-1" />
                            PERMISOS DE USUARIO
                          </span>
                        </Link>
                      </li>
                    </ul>
                  </li>
                )}

                <li>
                  <hr className="dropdown-divider" />
                </li>

                {accservicios && accservicios.substring(5, 6) === "0" ? (
                  ""
                ) : (
                  <li>
                    <a
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                      href="#"
                    >
                      <i className="fas fa-print fa-fw me-1" />
                      REPORTES »
                    </a>
                    <ul className="dropdown-menu dropdown-submenu sombras">
                      {accbtncreports &&
                        accbtncreports.substring(0, 1) === "1" ? (
                        <li onClick={abrirModal("reportefacturasdecompra")}>
                          <Link
                            to="#"
                            className="dropdown-item ripple bg-transparent text-dark fw-bold"
                          >
                            <span className="">
                              <i className="far fa-file-pdf fa-fw me-1" />
                              Movimientos de Ordenes de Servicio
                            </span>
                          </Link>
                        </li>
                      ) : (
                        ""
                      )}
                    </ul>
                  </li>
                )}
              </ul>
            </div>
          ) : (
            ""
          )}

          {permisos && permisos.substring(2, 3) === "1" ? (
            <div className="dropdown dropend">
              <a
                className="btn-primary dropdown-toggle list-group-item list-group-item-action py-2 ripple px-2"
                style={{
                  pointerEvents:
                    permisos && permisos.substring(2, 3) === "0"
                      ? "none"
                      : "cursor",
                  color:
                    permisos && permisos.substring(2, 3) === "0"
                      ? "rgb(183, 183, 183)"
                      : "#1d0345",
                  backgroundColor:
                    permisos && permisos.substring(2, 3) === "0"
                      ? "rgba(144, 143, 142, 0.76)"
                      : "transparent",
                }}
                type="button"
                id="dropdownMenuButton"
                data-mdb-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fas fa-shopping-cart fa-fw me-2" />
                <span className="fw-bold">COMPRAS</span>
              </a>
              <ul
                className="dropdown-menu sombras "
                aria-labelledby="dropdownMenuButton"
              >
                {acccompras && acccompras.substring(0, 1) === "0" ? (
                  ""
                ) : (
                  <li
                    onClick={bloquear("Registro de Contribuyentes por Minas")}
                  >
                    <Link
                      to="/proveedores"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-portrait fa-fw me-1" />
                        PROVEEDORES
                      </span>
                    </Link>
                  </li>
                )}

                {acccompras && acccompras.substring(1, 2) === "0" ? (
                  ""
                ) : (
                  <li onClick={bloquear("")}>
                    <Link
                      to="/ordencompra"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-edit fa-fw me-1" />
                        ORDENES DE COMPRAS
                      </span>
                    </Link>
                  </li>
                )}

                {acccompras && acccompras.substring(2, 3) === "0" ? (
                  ""
                ) : (
                  <li onClick={bloquear("Facturación de Compras")}>
                    <Link
                      to="/facturarordencompra"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-receipt fa-fw me-1" />
                        FACTURAS DE COMPRAS
                      </span>
                    </Link>
                  </li>
                )}

                {acccompras && acccompras.substring(3, 4) === "0" ? (
                  ""
                ) : (
                  <li>
                    <a
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                      href="#"
                    >
                      <span>
                        <i className="fas fa-cog fa-fw me-1" />
                        CONFIGURACION »
                      </span>
                    </a>
                    <ul className="dropdown-menu dropdown-submenu sombras">
                      <li onClick={abrirModal("Compras")}>
                        <Link
                          to="#"
                          className="dropdown-item ripple bg-transparent text-dark fw-bold"
                        >
                          <span>
                            <i className="fas fa-user-cog fa-fw me-1" />
                            PERMISOS DE USUARIO
                          </span>
                        </Link>
                      </li>
                    </ul>
                  </li>
                )}

                <li>
                  <hr className="dropdown-divider" />
                </li>

                {acccompras && acccompras.substring(4, 5) === "0" ? (
                  ""
                ) : (
                  <li>
                    <a
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                      href="#"
                    >
                      <i className="fas fa-print fa-fw me-1" />
                      REPORTES »
                    </a>
                    <ul className="dropdown-menu dropdown-submenu sombras">
                      {accbtncreports &&
                        accbtncreports.substring(0, 1) === "1" ? (
                        <li onClick={abrirModal("reportefacturasdecompra")}>
                          <Link
                            to="#"
                            className="dropdown-item ripple bg-transparent text-dark fw-bold"
                          >
                            <span className="">
                              <i className="far fa-file-pdf fa-fw me-1" />
                              Movimientos de Facturas de Compras
                            </span>
                          </Link>
                        </li>
                      ) : (
                        ""
                      )}
                    </ul>
                  </li>
                )}
              </ul>
            </div>
          ) : (
            ""
          )}

          {idorganizacion && idorganizacion === "1" && (iduser && parseInt(iduser) === 1 || parseInt(iduser) === 2 || parseInt(iduser) === 30) && permisos && permisos.substring(3, 4) === "1" ? (
            <div className="dropdown dropend ">
              <a
                className="btn-primary dropdown-toggle list-group-item list-group-item-action py-2 ripple px-2"
                style={{
                  pointerEvents:
                    permisos && permisos.substring(3, 4) === "0"
                      ? "none"
                      : "cursor",
                  color:
                    permisos && permisos.substring(3, 4) === "0"
                      ? "rgb(183, 183, 183)"
                      : "#1d0345",
                  backgroundColor:
                    permisos && permisos.substring(3, 4) === "0"
                      ? "rgba(144, 143, 142, 0.76)"
                      : "transparent",
                }}
                type="button"
                id="dropdownMenuButton"
                data-mdb-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fas fa-calculator fa-fw me-2" />
                <span className="fw-bold">CONTABILIDAD</span>
              </a>
              <ul
                className="dropdown-menu sombras "
                aria-labelledby="dropdownMenuButton"
              >
                {acccontabilidad && acccontabilidad.substring(0, 1) === "0" ? (
                  ""
                ) : (
                  <li onClick={bloquear("")}>
                    <Link
                      to="/catalogoContable"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-list-alt fa-fw me-1" />
                        CATALOGO CUENTA CONTABLE
                      </span>
                    </Link>
                  </li>
                )}

                {acccontabilidad && acccontabilidad.substring(1, 2) === "0" ? (
                  ""
                ) : (
                  <li onClick={bloquear("")}>
                    <Link
                      to="/asientoscontables"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-pen-square fa-fw me-1" />
                        ASIENTOS CONTABLES
                      </span>
                    </Link>
                  </li>
                )}

                {acccontabilidad && acccontabilidad.substring(2, 3) === "0" ? (
                  ""
                ) : (
                  <li onClick={bloquear("Retención 1x500")}>
                    <Link
                      to="/reten1x500"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-retweet fa-fw me-1" />
                        VINCULACIÓN DE CUENTAS
                      </span>
                    </Link>
                  </li>
                )}

                {acccontabilidad && acccontabilidad.substring(3, 4) === "0" ? (
                  ""
                ) : (
                  <li onClick={bloquear("")}>
                    <Link
                      to="/movimientotransi"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-exchange-alt fa-fw me-1" />
                        MOVIMIENTOS BANCARIOS EN TRANSITO
                      </span>
                    </Link>
                  </li>
                )}

                {acccontabilidad && acccontabilidad.substring(4, 5) === "0" ? (
                  ""
                ) : (
                  <li>
                    <a
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                      href="#"
                    >
                      <span>
                        <i className="fas fa-cog fa-fw me-1" />
                        CONFIGURACION »
                      </span>
                    </a>
                    <ul className="dropdown-menu dropdown-submenu sombras">
                      <li onClick={abrirModal("Contabilidad")}>
                        <Link
                          to="#"
                          className="dropdown-item ripple bg-transparent text-dark fw-bold"
                        >
                          <span>
                            <i className="fas fa-user-cog fa-fw me-1" />
                            PERMISOS DE USUARIO
                          </span>
                        </Link>
                      </li>
                    </ul>
                  </li>
                )}

                <li>
                  <hr className="dropdown-divider" />
                </li>

                {acccontabilidad && acccontabilidad.substring(5, 6) === "0" ? (
                  ""
                ) : (
                  <li>
                    <a
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                      href="#"
                    >
                      <i className="fas fa-print fa-fw me-1" />
                      REPORTES »
                    </a>
                    <ul className="dropdown-menu dropdown-submenu sombras"></ul>
                  </li>
                )}
              </ul>
            </div>
          ) : (
            ""
          )}

          {permisos && permisos.substring(4, 5) === "1" ? (
            <div className="dropdown dropend ">
              <a
                className="btn-primary dropdown-toggle list-group-item list-group-item-action py-2 ripple px-2"
                style={{
                  pointerEvents:
                    permisos && permisos.substring(4, 5) === "0"
                      ? "none"
                      : "cursor",
                  color:
                    permisos && permisos.substring(4, 5) === "0"
                      ? "rgb(183, 183, 183)"
                      : "#1d0345",
                  backgroundColor:
                    permisos && permisos.substring(4, 5) === "0"
                      ? "rgba(144, 143, 142, 0.76)"
                      : "transparent",
                }}
                type="button"
                id="dropdownMenuButton"
                data-mdb-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fas fa-coins fa-fw me-2" />
                <span className="fw-bold">FINANZAS</span>
              </a>
              <ul
                className="dropdown-menu sombras "
                aria-labelledby="dropdownMenuButton"
              >
                {accfinanzas && accfinanzas.substring(0, 1) === "0" ? (
                  ""
                ) : (
                  <li onClick={bloquear("")}>
                    <Link
                      to="/anticipos"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-pager fa-fw me-1" />
                        ANTICIPOS
                      </span>
                    </Link>
                  </li>
                )}
                {accfinanzas && accfinanzas.substring(0, 1) === "0" ? (
                  ""
                ) : (
                  <li onClick={abrirModal("banco")}>
                    <Link
                      to="#"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-landmark fa-fw me-1" />
                        BANCOS
                      </span>
                    </Link>
                  </li>
                )}

                {accfinanzas && accfinanzas.substring(1, 2) === "0" ? (
                  ""
                ) : (
                  <li onClick={bloquear("")}>
                    <Link
                      to="/beneficiarios"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-users fa-fw me-1" />
                        BENEFICIARIOS
                      </span>
                    </Link>
                  </li>
                )}

                {accfinanzas && accfinanzas.substring(2, 3) === "0" ? (
                  ""
                ) : (
                  <li onClick={bloquear("")}>
                    <Link
                      to="/cuentasbancarias"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-list-alt fa-fw me-1" />
                        CUENTAS BANCARIAS
                      </span>
                    </Link>
                  </li>
                )}

                {accfinanzas && accfinanzas.substring(3, 4) === "0" ? (
                  ""
                ) : (
                  <li onClick={bloquear("")}>
                    <Link
                      to="/movimientobanca"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-exchange-alt fa-fw me-1" />
                        MOVIMIENTOS BANCARIOS
                      </span>
                    </Link>
                  </li>
                )}

                {accfinanzas && accfinanzas.substring(4, 5) === "0" ? (
                  ""
                ) : (
                  <li onClick={bloquear("")}>
                    <Link
                      to="/movimientotransi"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-exchange-alt fa-fw me-1" />
                        MOVIMIENTOS EN TRANSITO
                      </span>
                    </Link>
                  </li>
                )}

                {accfinanzas && accfinanzas.substring(5, 6) === "0" ? (
                  ""
                ) : (
                  <li onClick={bloquear("")}>
                    <Link
                      to="/conciliacion"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-chalkboard-teacher fa-fw me-1" />
                        CONCILIACION BANCARIA
                      </span>
                    </Link>
                  </li>
                )}

                {accfinanzas && accfinanzas.substring(6, 7) === "0" ? (
                  ""
                ) : (
                  <li onClick={bloquear("")}>
                    <Link
                      to="/cuentasxcobrar"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-hand-holding-usd fa-fw me-1" />
                        CUENTAS POR COBRAR
                      </span>
                    </Link>
                  </li>
                )}

                {accfinanzas && accfinanzas.substring(11, 12) === "0" ? (
                  ""
                ) : (
                  <li onClick={bloquear("")}>
                    <Link
                      to="/reversarpago"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-undo fa-fw me-1" />
                        REVERSAR PAGO/ANTICIPO
                      </span>
                    </Link>
                  </li>
                )}

                {accfinanzas && accfinanzas.substring(7, 8) === "0" ? (
                  ""
                ) : (
                  <li onClick={bloquear("Asignación de Multas")}>
                    <Link
                      to="/cuentasxpagar"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-money-check-alt fa-fw me-1" />
                        CUENTAS POR PAGAR
                      </span>
                    </Link>
                  </li>
                )}

                {accfinanzas && accfinanzas.substring(8, 9) === "0" ? (
                  ""
                ) : (
                  <li onClick={bloquear("")}>
                    <Link
                      to="/tiporetenciones"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-list fa-fw me-1" />
                        TIPO DE RETENCIONES
                      </span>
                    </Link>
                  </li>
                )}

                {accfinanzas && accfinanzas.substring(9, 10) === "0" ? (
                  ""
                ) : (
                  <li>
                    <a
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                      href="#"
                    >
                      <span>
                        <i className="fas fa-cog fa-fw me-1" />
                        CONFIGURACION »
                      </span>
                    </a>
                    <ul className="dropdown-menu dropdown-submenu sombras">
                      <li onClick={abrirModal("Finanzas")}>
                        <Link
                          to="#"
                          className="dropdown-item ripple bg-transparent text-dark fw-bold"
                        >
                          <span>
                            <i className="fas fa-user-cog fa-fw me-1" />
                            PERMISOS DE USUARIO
                          </span>
                        </Link>
                      </li>
                    </ul>
                  </li>
                )}

                <li>
                  <hr className="dropdown-divider" />
                </li>

                {accfinanzas && accfinanzas.substring(10, 11) === "0" ? (
                  ""
                ) : (
                  <li>
                    <a
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                      href="#"
                    >
                      <i className="fas fa-print fa-fw me-1" />
                      REPORTES »
                    </a>
                    <ul className="dropdown-menu dropdown-submenu sombras">
                      {accbtnfreports &&
                        accbtnfreports.substring(0, 1) === "1" ? (
                        <li onClick={abrirModal("reporteestadodecuenta")}>
                          <Link
                            to="#"
                            className="dropdown-item ripple bg-transparent text-dark fw-bold"
                          >
                            <span className="">
                              <i className="far fa-file-pdf fa-fw me-1" />
                              Reporte de Estados de Cuenta
                            </span>
                          </Link>
                        </li>
                      ) : (
                        ""
                      )}

                      {accbtnfreports &&
                        accbtnfreports.substring(1, 2) === "1" ? (
                        <li onClick={abrirModal("reportecuentasporcobrar")}>
                          <Link
                            to="#"
                            className="dropdown-item ripple bg-transparent text-dark fw-bold"
                          >
                            <span className="">
                              <i className="far fa-file-pdf fa-fw me-1" />
                              Reporte de Cuentas por Cobrar
                            </span>
                          </Link>
                        </li>
                      ) : (
                        ""
                      )}

                      {accbtnfreports &&
                        accbtnfreports.substring(8, 9) === "1" ? (
                        <li onClick={abrirModal("repordeudasgen")}>
                          <Link
                            to="#"
                            className="dropdown-item ripple bg-transparent text-dark fw-bold"
                          >
                            <span className="">
                              <i className="far fa-file-pdf fa-fw me-1" />
                              Imprimir Deudas y Pagos Generados
                            </span>
                          </Link>
                        </li>
                      ) : (
                        ""
                      )}

                      {accbtnfreports &&
                        accbtnfreports.substring(2, 3) === "1" ? (
                        <li onClick={abrirModal("reporterecibodepago")}>
                          <Link
                            to="#"
                            className="dropdown-item ripple bg-transparent text-dark fw-bold"
                          >
                            <span className="">
                              <i className="far fa-file-pdf fa-fw me-1" />
                              Imprimir Recibo de Pago
                            </span>
                          </Link>
                        </li>
                      ) : (
                        ""
                      )}

                      {accbtnfreports &&
                        accbtnfreports.substring(3, 4) === "1" ? (
                        <li onClick={abrirModal("reporteanticipos")}>
                          <Link
                            to="#"
                            className="dropdown-item ripple bg-transparent text-dark fw-bold"
                          >
                            <span className="">
                              <i className="far fa-file-pdf fa-fw me-1" />
                              Imprimir Anticipos
                            </span>
                          </Link>
                        </li>
                      ) : (
                        ""
                      )}

                      {accbtnfreports &&
                        accbtnfreports.substring(7, 8) === "1" ? (
                        <li onClick={abrirModal("reporteanticiposxvendedor")}>
                          <Link
                            to="#"
                            className="dropdown-item ripple bg-transparent text-dark fw-bold"
                          >
                            <span className="">
                              <i className="far fa-file-pdf fa-fw me-1" />
                              Imprimir Anticipos por Vendedor
                            </span>
                          </Link>
                        </li>
                      ) : (
                        ""
                      )}

                      {accbtnfreports &&
                        accbtnfreports.substring(4, 5) === "1" ? (
                        <li onClick={abrirModal("reportelibrobanco")}>
                          <Link
                            to="#"
                            className="dropdown-item ripple bg-transparent text-dark fw-bold"
                          >
                            <span className="">
                              <i className="far fa-file-pdf fa-fw me-1" />
                              Imprimir Libro Auxiliar de Banco
                            </span>
                          </Link>
                        </li>
                      ) : (
                        ""
                      )}

                      {accbtnfreports &&
                        accbtnfreports.substring(5, 6) === "1" ? (
                        <li onClick={abrirModal("reporteingresos")}>
                          <Link
                            to="#"
                            className="dropdown-item ripple bg-transparent text-dark fw-bold"
                          >
                            <span className="">
                              <i className="far fa-file-pdf fa-fw me-1" />
                              Imprimir Ingresos
                            </span>
                          </Link>
                        </li>
                      ) : (
                        ""
                      )}

                      {accbtnfreports &&
                        accbtnfreports.substring(6, 7) === "1" ? (
                        <li onClick={abrirModal("reportelibroventas")}>
                          <Link
                            to="#"
                            className="dropdown-item ripple bg-transparent text-dark fw-bold"
                          >
                            <span className="">
                              <i className="far fa-file-pdf fa-fw me-1" />
                              Imprimir Libro de Ventas
                            </span>
                          </Link>
                        </li>
                      ) : (
                        ""
                      )}

                      {accbtnfreports &&
                        accbtnfreports.substring(9, 10) === "1" ? (
                        <li onClick={abrirModal("reporterecibosreversados")}>
                          <Link
                            to="#"
                            className="dropdown-item ripple bg-transparent text-dark fw-bold"
                          >
                            <span className="">
                              <i className="far fa-file-pdf fa-fw me-1" />
                              Imprimir Recibos Reversados
                            </span>
                          </Link>
                        </li>
                      ) : (
                        ""
                      )}
                    </ul>
                  </li>
                )}
              </ul>
            </div>
          ) : (
            ""
          )}

          {permisos && permisos.substring(6, 7) === "1" ? (
            <div className="dropdown dropend">
              <a
                className="btn-primary dropdown-toggle list-group-item list-group-item-action py-2 ripple px-2"
                style={{
                  pointerEvents:
                    permisos && permisos.substring(6, 7) === "0"
                      ? "none"
                      : "cursor",
                  color:
                    permisos && permisos.substring(6, 7) === "0"
                      ? "rgb(183, 183, 183)"
                      : "#1d0345",
                  backgroundColor:
                    permisos && permisos.substring(6, 7) === "0"
                      ? "rgba(144, 143, 142, 0.76)"
                      : "transparent",
                }}
                type="button"
                id="dropdownMenuButton"
                data-mdb-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fas fa-box-open fa-fw me-2" />
                <span className="fw-bold">GESTION DE VACIOS</span>
              </a>
              <ul
                className="dropdown-menu sombras "
                aria-labelledby="dropdownMenuButton"
              >
                {accvacios && accvacios.substring(2, 3) === "0" ? (
                  ""
                ) : (
                  <li onClick={abrirModal("classvacios")}>
                    <Link
                      to="#"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-receipt fa-fw me-1" />
                        CLASIFICADOR DE VACIOS
                      </span>
                    </Link>
                  </li>
                )}

                {accvacios && accvacios.substring(0, 1) === "0" ? (
                  ""
                ) : (
                  <li onClick={bloquear("")}>
                    <Link
                      to="/operacionesinvacio"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-exchange-alt fa-fw me-1" />
                        OPERACIONES DE INVENTARIO (VACIOS)
                      </span>
                    </Link>
                  </li>
                )}

                {accvacios && accvacios.substring(1, 2) === "0" ? (
                  ""
                ) : (
                  <li onClick={bloquear("")}>
                    <Link
                      to="/controlvacios"
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                    >
                      <span>
                        <i className="fas fa-edit fa-fw me-1" />
                        CONTROL DE VACIOS
                      </span>
                    </Link>
                  </li>
                )}

                {accvacios && accvacios.substring(3, 4) === "0" ? (
                  ""
                ) : (
                  <li>
                    <a
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                      href="#"
                    >
                      <span>
                        <i className="fas fa-cog fa-fw me-1" />
                        CONFIGURACION »
                      </span>
                    </a>
                    <ul className="dropdown-menu dropdown-submenu sombras">
                      <li onClick={abrirModal("Vacios")}>
                        <Link
                          to="#"
                          className="dropdown-item ripple bg-transparent text-dark fw-bold"
                        >
                          <span>
                            <i className="fas fa-user-cog fa-fw me-1" />
                            PERMISOS DE USUARIO
                          </span>
                        </Link>
                      </li>
                    </ul>
                  </li>
                )}

                <li>
                  <hr className="dropdown-divider" />
                </li>

                {accvacios && accvacios.substring(4, 5) === "0" ? (
                  ""
                ) : (
                  <li>
                    <a
                      className="dropdown-item ripple bg-transparent text-dark fw-bold"
                      href="#"
                    >
                      <i className="fas fa-print fa-fw me-1" />
                      REPORTES »
                    </a>
                    <ul className="dropdown-menu dropdown-submenu sombras">
                      {btnreportvacios &&
                        btnreportvacios.substring(0, 1) === "1" ? (
                        <li onClick={abrirModal("reportecontrolvacios")}>
                          <Link
                            to="#"
                            className="dropdown-item ripple bg-transparent text-dark fw-bold"
                          >
                            <span className="">
                              <i className="far fa-file-pdf fa-fw me-1" />
                              Imprimir Control de Vacios
                            </span>
                          </Link>
                        </li>
                      ) : (
                        ""
                      )}
                    </ul>
                  </li>
                )}
              </ul>
            </div>
          ) : (
            ""
          )}
          <div className="dropdown dropend">
            <a
              className="btn-primary dropdown-toggle list-group-item list-group-item-action py-2 ripple px-2"
              style={{
                color: "#1d0345",
                backgroundColor: "transparent",
              }}
              type="button"
              id="dropdownMenuButton"
              data-mdb-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fas fa-box-open fa-fw me-2" />
              <span className="fw-bold">GESTION GERENCIAL</span>
            </a>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <li onClick={bloquear("INDICADORES DE GESTIÓN")}>
                <Link
                  to="/gestionGerencial?modal=grafica"
                  className="dropdown-item ripple bg-transparent text-dark fw-bold"
                >
                  <span>
                    <i className="fas fa-receipt fa-fw me-1" />
                    INDICADORES DE GESTIÓN
                  </span>
                </Link>
              </li>
              <li onClick={bloquear("UBICACIÓN DE CLIENTES")}>
                <Link
                  to="/gestionGerencial?modal=mapaCliente"
                  className="dropdown-item ripple bg-transparent text-dark fw-bold"
                >
                  <span>
                    <i className="fas fa-receipt fa-fw me-1" />
                    UBICACIÓN DE CLIENTES
                  </span>
                </Link>
              </li>
              <li onClick={bloquear("RUTAS DE PEDIDOS")}>
                <Link
                  to="/gestionGerencial?modal=mapaAlmacen"
                  className="dropdown-item ripple bg-transparent text-dark fw-bold"
                >
                  <span>
                    <i className="fas fa-receipt fa-fw me-1" />
                    RUTAS DE PEDIDOS
                  </span>
                </Link>
              </li>
            </ul>
          </div>
          {permisos && permisos.substring(5, 6) === "1" ? (
            <a
              onClick={verConfig}
              className="btn-primary  list-group-item list-group-item-action py-2 ripple px-2"
              style={{
                pointerEvents:
                  permisos && permisos.substring(5, 6) === "0"
                    ? "none"
                    : "cursor",
                color:
                  permisos && permisos.substring(5, 6) === "0"
                    ? "rgb(183, 183, 183)"
                    : "#1d0345",
                backgroundColor:
                  permisos && permisos.substring(5, 6) === "0"
                    ? "rgba(144, 143, 142, 0.76)"
                    : "transparent",
              }}
              type="button"
            >
              <i className="fas fa-cogs fa-fw me-2" />
              <span className="fw-bold">CONFIGURACIÓN</span>
            </a>
          ) : (
            ""
          )}

          {idorganizacion && idorganizacion === "1" && (iduser && parseInt(iduser) === 1 || parseInt(iduser) === 2 || parseInt(iduser) === 30) ? (
            <a
              onClick={verConfigAthos}
              className="btn-primary  list-group-item list-group-item-action py-2 ripple px-2"
              style={{
                pointerEvents:
                  permisos && permisos.substring(5, 6) === "0"
                    ? "none"
                    : "cursor",
                color:
                  permisos && permisos.substring(5, 6) === "0"
                    ? "rgb(183, 183, 183)"
                    : "#1d0345",
                backgroundColor:
                  permisos && permisos.substring(5, 6) === "0"
                    ? "rgba(144, 143, 142, 0.76)"
                    : "transparent",
              }}
              type="button"
            >
              <i className="fas fa-cogs fa-fw me-2" />
              <span className="fw-bold">SISTEMA</span>
            </a>
          ) : (
            ""
          )}

          <div onClick={logout}>
            <Link
              to="/"
              className="btn-primary list-group-item list-group-item-action py-2 ripple bg-transparent px-2"
            >
              <i className="fas fa-power-off fa-fw me-2 text-danger" />{" "}
              <span className="text-danger fw-bold">Salir</span>
            </Link>
            {/* <hr style={{ margin: 0, padding: 0, height: 0 }} /> */}
          </div>
          <br />
        </div>

        <GestionarMedida
          show={mostrarMedida}
          onHideRenderizar={() => { }}
          onHideCancela={() => {
            setMostrarMedida(false);
          }}
        />

        <GestionarBanco
          show={mostrarBanco}
          onHideRenderizar={() => { }}
          onHideCancela={() => {
            setMostrarBanco(false);
          }}
        />

        <GestionarProducto
          show={mostrarProducto}
          onHideCancela={() => {
            setMostrarProducto(false);
          }}
        />

        <GestionarMarca
          show={mostrarMarca}
          onHideRenderizar={() => { }}
          onHideCancela={() => {
            setMostrarMarca(false);
          }}
          llamado={1}
        />

        <GestionarModelo
          show={mostrarModelo}
          onHideRenderizar={() => { }}
          onHideCancela={() => {
            setMostrarModelo(false);
          }}
          llamado={1}
        />

        <GestionarFabricantes
          show={mostrar}
          onHideRenderizar={() => { }}
          onHideCancela={() => {
            setMostrar(false);
          }}
          llamado={1}
        />

        <GestionarDepartamento
          show={mostrarDepart}
          onHideRenderizar={() => { }}
          onHideCancela={() => {
            setMostrarDepart(false);
          }}
          llamado={1}
        />

        <GestionarClasificadorVacios
          show={mostrar8}
          onHideRenderizar={() => { }}
          onHideCancela={() => {
            setMostrar8(false);
          }}
          llamado={1}
        />

        <GestionarpServicios
          show={mostrar9}
          onHideRenderizar={() => { }}
          onHideCancela={() => {
            setMostrar9(false);
          }}
          llamado={1}
        />

        <GestionarTipoProducto
          show={mostrarTipoProducto}
          onHideRenderizar={() => { }}
          onHideCancela={() => {
            setMostrarTipoProducto(false);
          }}
          llamado={1}
        />

        <GestionarTipoVacio
          show={mostrarTipoVacio}
          onHideCancela={() => {
            setMostrarTipoVacio(false);
          }}
        />

        <ImprimirProductos
          show={mostrarReportProductos}
          op={1}
          onHideCancela={() => {
            setMostrarReportProductos(false);
          }}
        />

        <ImprimirNotasdeDebitos
          show={mostrarReportNDebitos}
          op={1}
          report={creport}
          onHideCancela={() => {
            setMostrarReportNDebitos(false);
          }}
        />

        <ImprimirNotasdeCredito
          show={mostrarReportNCredito}
          op={1}
          report={creport}
          onHideCancela={() => {
            setMostrarReportNCredito(false);
          }}
        />

        <ImprimirCuentasxCobrarEstadosCuentas
          show={mostrarReportEsc}
          op={1}
          report={creportestc}
          onHideCancela={() => {
            setMostrarReportEsc(false);
          }}
        />

        <ImprimirDeudasGenerales
          show={mostrar12}
          ope={1}
          onHideCancela={() => {
            setMostrar12(false);
          }}
        />

        <ImprimirControlVacios
          show={mostrar13}
          ope={1}
          onHideCancela={() => {
            setMostrar13(false);
          }}
        />

        <ModalImprimirRecibosdePago
          show={mostrar2}
          ope={1}
          report={creportestc}
          onHideCancelar={() => {
            setMostrar2(false);
          }}
        />

        <ImprimirAnticipos
          show={mostrar4}
          ope={1}
          onHideCancelar={() => {
            setMostrar4(false);
          }}
        />

        <ImprimirAnticiposxVendedor
          show={mostrar11}
          ope={1}
          onHideCancelar={() => {
            setMostrar11(false);
          }}
        />

        <ModalImprimirIngresos
          show={mostrar10}
          ope={1}
          val={valrport}
          onHideCancelar={() => {
            setMostrar10(false);
          }}
        />

        <ModalImprimirOpObsequio
          show={mostrar14}
          ope={1}
          onHideCancelar={() => {
            setMostrar14(false);
          }}
        />

        <ImpMovBanLibro
          show={mostrar5}
          ope={1}
          onHideCancelar={() => {
            setMostrar5(false);
          }}
        />

        <ModalVentasxProductos
          show={mostrar6}
          ope={1}
          onHideCancelar={() => {
            setMostrar6(false);
          }}
        />

        <ModalImprimirFacturasCompras
          show={mostrar7}
          ope={1}
          onHideCancelar={() => {
            setMostrar7(false);
          }}
        />

        <ModalOperacionesInventario
          show={mostrar1}
          ope={1}
          report={creportestc}
          onHideCancelar={() => {
            setMostrar1(false);
          }}
        />

        <ModalVentasGanancias
          show={mostrar3}
          ope={1}
          report={creportestc}
          onHideCancelar={() => {
            setMostrar3(false);
          }}
        />
        <ModalPedidosPendientes
          show={mostrar15}
          ope={1}
          report={creportestc}
          onHideCancelar={() => {
            setMostrar15(false);
          }}
        />
        <ModalImprimirRecibosReversados
          show={mostrar16}
          ope={1}
          report={creportestc}
          onHideCancelar={() => {
            setMostrar16(false);
          }}
        />
        <ModalClientes
          show={mostrar17}
          ope={1}
          report={creportestc}
          onHideCancelar={() => {
            setMostrar17(false);
          }}
        />
        <ModalPicking
          show={mostrar18}
          ope={1}
          report={creportestc}
          onHideCancelar={() => {
            setMostrar18(false);
          }}
        />
        <CatPermisosUsuarios
          show={mpermisousuarios}
          op={1}
          nom={tipopermi}
          onHideCancela={() => {
            setMpermisousuarios(false);
          }}
        />

        <GestionarUbicaciones
          show={mostrarUbicaciones}
          onHideCancela={() => {
            setMostrarUbicaciones(false);
          }}
        />
      </div>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <VerConfiguracion show={verConfiguracion} onHideCancela={verConfig} />
      <VerConfiguracionAthos
        show={verConfiguAthos}
        onHideCancela={() => setVerConfiguAthos(false)}
      />
    </div>
  );

  return sidebar;
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/sidebar.js